"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Checkbox = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _omit2 = _interopRequireDefault(require("lodash/omit"));

var _Field = require("../Field");

var Checkbox =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Checkbox, _React$Component);

  function Checkbox(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Checkbox);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Checkbox).call(this, props));
    _this.shouldComponentUpdate = _reactAddonsPureRenderMixin["default"].shouldComponentUpdate.bind((0, _assertThisInitialized2["default"])((0, _assertThisInitialized2["default"])(_this)));
    return _this;
  }

  (0, _createClass2["default"])(Checkbox, [{
    key: "render",
    value: function render() {
      var props = (0, _objectSpread2["default"])({
        checked: this.props.value
      }, this.props);
      props = (0, _omit2["default"])(props, 'toolbar');
      return _react["default"].createElement("input", (0, _extends2["default"])({}, props, {
        type: "checkbox"
      }));
    }
  }]);
  return Checkbox;
}(_react["default"].Component);

exports.Checkbox = Checkbox;
Checkbox.displayName = 'CheckboxField';
Checkbox.propTypes = process.env.NODE_ENV !== "production" ? {
  checked: _propTypes["default"].bool,

  /**
   * Synonymous with `checked`
   */
  value: _propTypes["default"].bool
} : {};
var CheckboxField = (0, _Field.wrapWith)({
  fieldProps: {
    type: 'checkbox'
  }
})(Checkbox);
var _default = CheckboxField;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/CheckboxField/index.js
// module id = 400
// module chunks = 0